import { proxy } from 'valtio';

export interface MatchIndexResults {
  /**
   * The index (0th indexing) of the list of all matches. The actual count would be this index + 1
   * So for instance, in the string '3 of 10', this index would be 2.
   * If the index has not been computed, this can be null. In the search dialog, this is represented by a '?' character.
   */
  index: number | null;

  /**
   * The total number of matches, eg the '10' in '3 of 10'.
   */
  total: number;
}
export interface FindReplaceState {
  /**
   * The user-entered search term in the find dialog
   */
  searchTerm: string;

  /**
   * Whether to match the case of the search term
   */
  matchCase: boolean;

  /**
   * Whether to search for whole words, ie surrounded by non-letters, eg <another word> <the term> <another word>
   */
  wholeWord: boolean;

  /**
   * Whether the find/replace dialog is currently focused
   */
  focused: boolean;

  /**
   * An object containing the current index of the active match, and how many matches there are.
   *
   * The absence of this object refers to there being no search results to render, and consequently
   * this will close the navigation carets if undefined.
   */
  count?: MatchIndexResults;
}

export const defaultFindReplaceState: FindReplaceState = {
  searchTerm: '',
  focused: false,
  matchCase: false,
  wholeWord: false,
};

export const currentFindReplaceState: FindReplaceState = proxy(defaultFindReplaceState);
